import { BCExtremeGridEntities } from '@bimser/components';
import { DmData, IDmData } from '../../../entities/IDmData';
import { ServiceList } from '../../../services/serviceList';
import { customErrorHandlerWithThrow, GenerateDmModel } from '../../../utilities/helpers';

const GetFolderItems = async (
	loadOptions: BCExtremeGridEntities.ILoadOptions,
	secretKey: string,
	addToStore: (items: Array<DmData>) => void
) => {
	const { items, totalCount }: { items: Array<IDmData>; totalCount: number } =
		await ServiceList.dm.DocumentManagement.Objects.GetFolderItems.handleError(
			customErrorHandlerWithThrow
		).callPromise({ loadOptions, secretKey }, true);

	if (!items) return { data: [] };

	const dmData = items.map(GenerateDmModel);
	addToStore?.(dmData);
	const data: Array<IDmData['metadata']> =
		dmData.map((item: DmData) => ({
			...item.metadata.toJS(),
			baseItem: item,
			existThumbnail: item.existThumbnail
		})) || [];

	return { data, totalCount, dmData };
};

export default GetFolderItems;
